import React, { Component } from 'react';
import { NavigateFunction } from 'react-router-dom';
import './DashboardPage.css';

interface DashboardPageProps {
  navigate: NavigateFunction;
}

interface DashboardPageState {
  loading: boolean;
}

class DashboardPage extends Component<DashboardPageProps, DashboardPageState> {
  constructor(props: DashboardPageProps) {
    super(props);
    this.state = {
      loading: false
    };
  }

  componentDidMount() {
    console.log('DashboardPage mounted with navigate prop:', this.props.navigate);
  }

  _onNavigateToGoals = () => {
    this.props.navigate('/goals');
  };

  _onNavigateToCalendar = () => {
    this.props.navigate('/calendar');
  };

  _onNavigateToAnnouncements = () => {
    this.props.navigate('/announcements');
  };

  _onNavigateToSettings = () => {
    this.props.navigate('/settings');
  };

  render() {
    const { loading } = this.state;

    return (
      <div className="dashboard-page">
        <div className="dashboard-container">
          <div className="page-header">
            <h1>Dashboard</h1>
            <p>This is the Dashboard page - coming soon!</p>
          </div>
          
          <div className="page-content">
            <div className="feature-card">
              <h3>Features</h3>
              <ul>
                <li>✅ Page structure ready</li>
                <li>✅ CSS styling prepared</li>
                <li>✅ Redux integration ready</li>
                <li>✅ Navigation working</li>
                <li>🔄 Component implementation pending</li>
              </ul>
            </div>
            
            <div className="status-card">
              <h3>Page Status</h3>
              <p>✅ Route: /dashboard</p>
              <p>✅ Component: DashboardPage</p>
              <p>✅ Category: Dashboard</p>
              <p>✅ Navigation: Working</p>
              <p>🔄 Content: Ready for implementation</p>
            </div>

            <div className="navigation-card">
              <h3>Navigation Test</h3>
              <div className="nav-buttons">
                <button onClick={this._onNavigateToGoals}>Go to Goals</button>
                <button onClick={this._onNavigateToCalendar}>Go to Calendar</button>
                <button onClick={this._onNavigateToAnnouncements}>Go to Announcements</button>
                <button onClick={this._onNavigateToSettings}>Go to Settings</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DashboardPage;
